
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function AssetGrid() {
  const assets = [
    {
      id: 1,
      name: 'AutoContent Pro Agency',
      tagline: 'Full-service AI content marketing agency',
      price: '$450K',
      mrr: '$38K',
      clients: '50+ active clients',
      category: 'AI Agency',
      industry: 'Marketing',
      status: 'For Sale',
      verified: true,
      featured: true
    },
    {
      id: 2,
      name: 'LegalAI Services',
      tagline: 'Established legal AI service bureau',
      price: '$750K',
      mrr: '$62K',
      clients: '200+ law firms',
      category: 'AIaaS',
      industry: 'Legal',
      status: 'For Sale',
      verified: true,
      featured: true
    },
    {
      id: 3,
      name: 'HealthBot Agency',
      tagline: 'Healthcare AI automation specialists',
      price: '$320K',
      mrr: '$28K',
      clients: '30+ medical practices',
      category: 'AI Agency',
      industry: 'Healthcare',
      status: 'Partnership',
      verified: true,
      featured: false
    },
    {
      id: 4,
      name: 'PropTech AI Agency',
      tagline: 'Real estate AI service provider',
      price: '$580K',
      mrr: '$45K',
      clients: '100+ property portfolios',
      category: 'AI Agency',
      industry: 'Real Estate',
      status: 'For Sale',
      verified: true,
      featured: true
    },
    {
      id: 5,
      name: 'FinanceFlow AIaaS',
      tagline: 'Enterprise financial AI services',
      price: '$1.2M',
      mrr: '$95K',
      clients: 'Fortune 500 clients',
      category: 'AIaaS',
      industry: 'Finance',
      status: 'For Sale',
      verified: true,
      featured: true
    },
    {
      id: 6,
      name: 'E-Commerce AI Agency',
      tagline: 'Full-service e-commerce AI optimization',
      price: '$425K',
      mrr: '$35K',
      clients: '80+ brands',
      category: 'AI Agency',
      industry: 'E-Commerce',
      status: 'For Sale',
      verified: true,
      featured: false
    }
  ];

  return (
    <section className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {assets.map((asset) => (
            <Card key={asset.id} className="group hover:scale-[1.02] transition-all duration-300">
              <div className="p-8">
                {/* Header */}
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-center space-x-3">
                    {asset.verified && (
                      <div className="w-2 h-2 bg-green-400 rounded-full" />
                    )}
                    {asset.featured && (
                      <span className="px-3 py-1 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 text-blue-400 text-xs font-medium rounded-full border border-blue-500/30">
                        Featured
                      </span>
                    )}
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-light text-white mb-1">{asset.price}</div>
                    <div className="text-sm text-gray-500">Asking Price</div>
                  </div>
                </div>

                {/* Content */}
                <div className="mb-6">
                  <h3 className="text-xl font-medium text-white mb-2 group-hover:text-blue-400 transition-colors duration-200">
                    {asset.name}
                  </h3>
                  <p className="text-gray-400 mb-4 font-light">
                    {asset.tagline}
                  </p>
                  
                  {/* Metrics */}
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div>
                      <div className="text-lg font-medium text-white">{asset.mrr}</div>
                      <div className="text-xs text-gray-500 uppercase tracking-wider">Monthly Revenue</div>
                    </div>
                    <div>
                      <div className="text-lg font-medium text-white">{asset.clients}</div>
                      <div className="text-xs text-gray-500 uppercase tracking-wider">Client Base</div>
                    </div>
                  </div>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2 mb-6">
                    <span className="px-3 py-1 bg-white/5 text-gray-400 text-xs rounded-full border border-white/10">
                      {asset.category}
                    </span>
                    <span className="px-3 py-1 bg-white/5 text-gray-400 text-xs rounded-full border border-white/10">
                      {asset.industry}
                    </span>
                    <span className={`px-3 py-1 text-xs rounded-full ${
                      asset.status === 'For Sale' 
                        ? 'bg-green-500/20 text-green-400 border border-green-500/30' 
                        : 'bg-blue-500/20 text-blue-400 border border-blue-500/30'
                    }`}>
                      {asset.status}
                    </span>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex space-x-3">
                  <Button variant="primary" size="sm" className="flex-1">
                    View Details
                  </Button>
                  <Button variant="outline" size="sm" className="flex-1">
                    Request Info
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Load More */}
        <div className="text-center mt-16">
          <Button variant="outline" size="lg">
            Load More Agencies
            <i className="ri-arrow-down-line ml-2"></i>
          </Button>
        </div>
      </div>
    </section>
  );
}
